export enum ScopeOverviewTab {
  CONFIGURATION = 'Configuration',
  SCOPE = 'Scope',
  ACTIVITY = 'Activity',
  DETAILS = 'Details',
  TEAM = 'Team',
  BREAKDOWN = 'Breakdown',
  OUTPUT_EDITOR = 'Output Editor',
}
